/* eslint-disable */

import { rootApi } from '../rootApi';

export const lookupApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLookUpDropdownList: builder.query({
            query: (params) => {
                // Base parameters
                const queryParams = {
                    LanguageId: params?.LanguageId || 1,
                    GroupCode: params?.GroupCode !== undefined ? params.GroupCode : 'XXBOS_AFTER_WARR_TYPE',
                    Code: params?.SearchText || ''
                };

                return {
                    url: 'v1/lookup/get',
                    params: queryParams
                };
            },
            transformResponse: (response) => {
                // Check if response has the expected structure with data property
                if (response && typeof response === 'object') {
                    if (response.data && Array.isArray(response.data)) {
                        return response.data;
                    }

                    // If response itself is an array, return it directly
                    if (Array.isArray(response)) {
                        return response;
                    }
                }

                // Fallback: return empty array if structure doesn't match
                console.warn('⚠️ Response structure not as expected, returning empty array');
                return [];
            },
            // Keep track of API state for debugging
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {
                    console.error('❌ getLookUpDropdownList query failed:', error);
                }
            },
            providesTags: ['Lookup']
        })
    })
});

export const { useGetLookUpDropdownListQuery } = lookupApi;
